import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";


const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius:30px;
  border: 4px solid var(--secondary-text);
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  font-size: 20px;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  :active {
    background-color: var(--third);
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponMember = styled.div`
  display: grid;
  align-items: stretched;
  grid-template-columns:1fr 1fr;
  justify-content: stretched;
  text-align:center;
  width: 100%;
  @media (min-width: 767px) {
    grid-template-columns:repeat(5,1fr);
  }
`;
export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;
export const StyledLogo = styled.img`
  width:200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledIcon = styled.img`
  
  width:50px;
  @media (min-width: 767px) {
    width: 80px;
  }
  margin: 5px;
  transition: width 0.5s;
  transition: height 0.5s;
`;
export const StyledImg = styled.img`
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;
export const StyledRm = styled.img`
 width:100%;
@media (min-width: 767px) {
  width: 80%;
}
  
  transition: width 0.5s;
`;
export const StyledMembrImg = styled.img`
  width: 100px;
  border-radius: 100%;
  @media (min-width: 900px) {
    width: 150px;
  }
  @media (min-width: 1000px) {
    width: 200px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;



function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 50) {
      newMintAmount = 50;
    }
    setMintAmount(newMintAmount);
  };
  const left =() =>{
    let leftnft= 3-1;

   };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);


  return (
    <s.Screen>

      <s.Container flex={1} ai={"center"} style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >
        <a>
          <StyledLogo alt={"logo"} src={"/config/images/logo.png"} />
        </a>
        <s.SpacerSmall />
        <span>
          <a href={CONFIG.SocialMedia_LINK}>
            <StyledIcon alt={"Twitter"} src={"/config/images/Twitter.png"} />
          </a>
          <a href={CONFIG.MARKETPLACE_LINK}>
            <StyledIcon alt={"OC"} src={"/config/images/OC.png"} />
          </a>
        </span>
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container flex={2} jc={"center"} ai={"center"}
            style={{ backgroundColor: "var(--accent)", padding: 24, borderRadius: 24 }}>
            <s.TextTitle
              style={{
                textAlign: "center", fontSize: 40,
                fontWeight: "bold", color: "var(--secondary)",
              }}>
              <p> HAVING AN ADVENTUE</p>
              <p>  WITH AVERY</p>
            </s.TextTitle>
            <s.SpacerXSmall />
            <s.TextTitle style={{
              textAlign: "center", fontSize: 22,
              fontWeight: "bold", color: "var(--accent-text)",
            }}>
              {CONFIG.MAX_SUPPLY} {CONFIG.SYMBOL}         
            </s.TextTitle>
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}>
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }} >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                
                {blockchain.account === "" ||
                  blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{ textAlign: "center", color: "var(--accent-text)",fontSize: 22, }}>
                      MINT IT NOW
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                     onClick={(e) => {
                       e.preventDefault();
                       dispatch(connect());
                       getData();}}
                        >
                      Mint
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center", color: "var(--accent-text)",
                          }} >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{ textAlign: "center", color: "var(--accent-text)", }}>
                     <p> {CONFIG.MAX_SUPPLY-data.totalSupply} {CONFIG.SYMBOL} Left</p>
                     <p> Free Mint  </p>
                     
                    </s.TextDescription>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => { e.preventDefault(); decrementMintAmount(); }} >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "BUY"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"Avery_-example"} src={"/config/images/Avery_-example.gif"} />
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerMedium />
        <a>
          <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
            <s.Container flex={2} jc={"center"}>
              <s.TextDescription style={{ textAlign: "left", color: "var(--primary-text)", fontSize: 20 }} >
                <p>Avery is a warm, lovely and full of courage kid . Like Travel all over the world,whether it is forest, ocean or space!</p>
                <p>During the journey, Avery will meet all kinds of magical animals and adventures together!Lead you to find the heart full of curiosity about the unknown world.</p>
                <p>Avery was the embodiment of our childhood memories.Playful ,confident, and has no fear of the future!</p>
                <p>Welcome to join the world of avery, dream and adventure together!</p>
              </s.TextDescription>
              <s.TextDescription style={{ textAlign: "left", color: "#ffff9d", fontSize: 20 }} >
                <p> <img src="/config/images/point.png"alt="point" />Ethereum ERC20 Token </p>
                <p> <img src="/config/images/point.png"alt="point" />555 unique non-fungible tokens </p>
                <p> <img src="/config/images/point.png"alt="point" />Free Mint </p>
                <p> <img src="/config/images/point.png"alt="point" />Available to purchase on OpenSea </p>
              </s.TextDescription>
            </s.Container>
            <s.Container flex={1} jc={"center"} ai={"center"}>
              <StyledImg alt={"Avery_-example01"} src={"/config/images/Avery_-example01.gif"} />
            </s.Container>
          </ResponsiveWrapper>
        </a>
              
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <s.TextTitle style={{
              textAlign: "center", fontSize: 50, fontWeight: "bold",
              color: "var(--forth)",
            }}>
              Team
            </s.TextTitle>
            <ResponMember flex={1} style={{ padding: 3 }} test>
              <s.Container flex={1} jc={"center"} ai={"center"}>
                <StyledMembrImg src={"/config/images/1_Director.png"} />
                <s.TextDescription style={{ textAlign: "", color: "var(--primary-text)", }}>
                  Kallie-Directer
                </s.TextDescription>
              </s.Container>
              <s.Container flex={1} jc={"center"} ai={"center"}>
                <StyledMembrImg src={"/config/images/2_Artist.png"} />
                <s.TextDescription style={{ textAlign: "", color: "var(--primary-text)", }}>
                  Morton-Artist
                </s.TextDescription>
              </s.Container>
              <s.Container flex={1} jc={"center"} ai={"center"}>
                <StyledMembrImg src={"/config/images/3_Artist.png"} />
                <s.TextDescription style={{ textAlign: "", color: "var(--primary-text)", }}>
                  Maureen-Artist
                </s.TextDescription>
              </s.Container>
              <s.Container flex={1} jc={"center"} ai={"center"}>
                <StyledMembrImg src={"/config/images/4_Engineer.png"} />
                <s.TextDescription style={{ textAlign: "", color: "var(--primary-text)", }}>
                  Emalee-Engineer
                </s.TextDescription>
              </s.Container>
              <s.Container flex={1} jc={"center"} ai={"center"}>
                <StyledMembrImg src={"/config/images/5_Martketing.png"} />
                <s.TextDescription style={{ textAlign: "", color: "var(--primary-text)", }}>
                  Haleigh-Marketing
                </s.TextDescription>
              </s.Container>
            </ResponMember >
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerSmall />
        <s.TextDescription
          style={{ textAlign: "center", color: "var(--primary-text)", }} >
          Copyright © 2022 - AVERY ALL RIGHTS RESERVED LICENSE AGREEMENT
        </s.TextDescription>
      </s.Container>

    </s.Screen>
  );
}

export default App;
